import {
  CHANGE_SELECT_LANGUAGE,
  USER_CHAT_LIST,
  XMPP_CLIENT,
  CHAT_HISTORY,
  CHAT_MSG,
  AIRPORT_LIST,
} from "./actionTypes";

export const fetchChangeLanguage = (payload) => async (dispatch) => {
  dispatch({
    type: CHANGE_SELECT_LANGUAGE,
    payload: payload,
  });
};

export const fetchChatuserlist = (userchatlist) => async (dispatch) => {
  dispatch({
    type: USER_CHAT_LIST,
    userchatlist: userchatlist,
  });
};

export const storeConnection = (xmppclient) => async (dispatch) => {
  dispatch({
    type: XMPP_CLIENT,
    xmppclient: xmppclient,
  });
};

export const storeChathistory = (chathistory) => async (dispatch) => {
  dispatch({
    type: CHAT_HISTORY,
    chathistory: chathistory,
  });
};

export const storeChat = (msg) => async (dispatch) => {
  dispatch({
    type: CHAT_MSG,
    msg: msg,
  });
};

export const maintainAirportlist = (airport_list) => async (dispatch) => {
  dispatch({
    type: AIRPORT_LIST,
    airport_list: airport_list,
  });
};
